import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { chatbotService } from '../../../services/ChatbotService';
import { chatbotQueryKeys } from '../chatbotQueryKeys';

export function useChatbotsQuery() {
  const { user } = useAuth();
  const isEnabled = Boolean(user);

  return useQuery({
    queryKey: chatbotQueryKeys.list(),
    enabled: isEnabled,
    queryFn: () => chatbotService.listAccessibleChatbots(),
  });
}
